import Layout from "../views/Layouts/DashboardLayout.vue";

import ListUser from "../views/User/User/ListUser.vue";
import UserInfo from "../views/User/User/UserInfo.vue";

export default {
  path: "/users",
  component: Layout,
  meta: {
    auth: true
  },
  children: [
    {
      path: "",
      redirect: "/users/management"
    },
    {
      path: "management",
      name: "Users Management",
      component: ListUser
    },
    {
      path: "management/view/:id",
      name: "User Management",
      component: UserInfo,
      props: route => (
        {
          id: route.params.id,
          edit: Object.keys(route.query).includes("edit")
        }
      )
    },
    {
      path: "management/add",
      name: "User Add",
      component: UserInfo,
      props: () => (
        {
          id: "",
          edit: true
        }
      )
    }
  ]
};
